<template>
  <MenuPage :_categories="categories" />
</template>

<script>
import MenuPage from '@/components/pages/common/MenuPage'
import { FunctionCd, S3Root, ManualFileName } from '@/enum'

export default {
  name: 'MasterMenuPage',

  components: {
    MenuPage,
  },

  data() {
    return {
      categories: [],
    }
  },

  mounted() {
    if (!this.$store.getters.canMasterMaintenance) {
      this.$router.push({ name: 'TopMenu' }).catch(() => {})
    }

    this.categories = [
      {
        name: this.$t('ELE0062'),
        size: 2,
        icon: 'mdi-database-edit',
        color: '#FCF4A1',
        iconColor: '#948D2B',
        items: [
          { functionCd: FunctionCd.COMPANY, route: 'M01' },
          { functionCd: FunctionCd.PART, route: 'M02' },
          { functionCd: FunctionCd.INPT_CHARAC, route: 'M03' },
          { functionCd: FunctionCd.INSP_ATTACH, route: 'M04' },
          { functionCd: FunctionCd.USER, route: 'M05' },
          { functionCd: FunctionCd.MEAS_INST, route: 'M06' },
          { functionCd: FunctionCd.DEFECT, route: 'M07' },
          { functionCd: FunctionCd.DEFECT_GROUP, route: 'M08' },
          { functionCd: FunctionCd.XRF_GROUP, route: 'M11' },
        ],
      },
      {
        name: this.$t('ELE0063'),
        size: 2,
        icon: 'mdi-format-list-checks',
        color: '#BBD9F3',
        iconColor: '#8BA9C3',
        items: [
          { functionCd: FunctionCd.CHECK_LATEST_PARTS, route: 'M09' },
          { functionCd: FunctionCd.INSP_FILT_UDPATE, route: 'M10' },
        ],
      },
      {
        name: this.$t('ELE0337'),
        size: 2,
        icon: 'mdi-download',
        color: '#C9E0A7',
        iconColor: '#3A8A3E',
        isManualDownLoad: true,
        items: [{ name: this.$t('ELE0062'), filePath: S3Root.MANUAL + '/' + ManualFileName.MASTER }],
      },
    ]
  },
}
</script>
